import PackmanPieIcon from './PackmanPieIcon'

export default PackmanPieIcon
